import React from "react";
import { Plus } from "lucide-react";
import { useCreatePath, useResourceContext, useTranslate } from "ra-core";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

export type CreateButtonProps = {
  label?: string;
  resource?: string;
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link";
  className?: string;
};

export const CreateButton = ({
  label,
  resource: targetResource,
  variant = "outline",
  className = "bg-white text-black hover:bg-gray-100",
}: CreateButtonProps) => {
  const resource = useResourceContext();
  const createPath = useCreatePath();
  const translate = useTranslate(); // 👈 Use the hook instead of the component

  const link = createPath({
    resource: targetResource ?? resource,
    type: "create",
  });

  return (
    <Button variant={variant} className={className} asChild>
      <Link to={link} onClick={stopPropagation} className="font-normal">
        <Plus className="mr-2 h-4 w-4" />
        {/* 👈 Raw translation string, no span wrapper */}
        {label
          ? translate(label)
          : translate("ra.action.create", { _: "Create" })}
      </Link>
    </Button>
  );
};

const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();
